import axios from 'axios'

// Fire-and-forget engagement pings from the customer embeds. Never throws,
// never blocks render. Posts to the public embed track endpoint, which
// attributes the event to the grouping's reseller. No PII — just a random
// per-tab session id so repeat events from one visit can be de-duped later.
const apiOrigin = import.meta.env.VITE_API_ORIGIN || window.location.origin

function sessionId() {
  try {
    let s = sessionStorage.getItem('ig_embed_sid')
    if (!s) {
      s = Math.random().toString(36).slice(2) + Date.now().toString(36)
      sessionStorage.setItem('ig_embed_sid', s)
    }
    return s
  } catch { return null }
}

// Funnel stages — must match the backend whitelist.
const ALLOWED = new Set(['view', 'search', 'results', 'hotel_select', 'round_select', 'checkout_start', 'book'])

export function trackEmbed(iframeKey, eventType, surface, props) {
  if (!iframeKey || !ALLOWED.has(eventType)) return
  try {
    axios.post(
      `${apiOrigin}/api/public/reseller-embed/${iframeKey}/track`,
      { eventType, surface: surface || null, sessionId: sessionId(), props: props || null },
      { validateStatus: () => true, timeout: 4000 }
    ).catch(() => {})
  } catch { /* never surface to the widget */ }
}

// The account-wide search embed is keyed by account slug, not a grouping key.
export function trackAccountEmbed(accountSlug, eventType, surface, props) {
  if (!accountSlug || !ALLOWED.has(eventType)) return
  try {
    axios.post(
      `${apiOrigin}/api/public/reseller-search/${accountSlug}/track`,
      { eventType, surface: surface || 'search', sessionId: sessionId(), props: props || null },
      { validateStatus: () => true, timeout: 4000 }
    ).catch(() => {})
  } catch { /* never surface to the widget */ }
}
